import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import {Toolbar, Typography} from "@material-ui/core";

const styles = theme => ({
    root: {
        paddingRight: theme.spacing(1),
        backgroundColor: '#d8d8d8'
    },
    title: {
        flex: '0 0 auto'
    },
    spacer: {
        flex: '1 1 100%'
    }
});

const RegistrationToolbar = props => {
    const {classes, title} = props;

    return (
        <Toolbar className={classes.root}>
            <div className={classes.title}>
                <Typography color="inherit" variant="h6">
                    {title}
                </Typography>
            </div>
            <div className={classes.spacer} />
        </Toolbar>
    );
};

export default withStyles(styles)(RegistrationToolbar);